module.exports = __webpack_public_path__ + "img/econect.4a9a1213.png";